// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import App from './App'
import router from './router'
import axios from 'axios'
Vue.prototype.axios = axios
import app from './components/common/js/App'
import Qs from 'qs'

import Vuex from 'vuex'
import VueWechatTitle from 'vue-wechat-title'
// swiper 4.x
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueWechatTitle)
Vue.use(Vuex)
Vue.use(iView)
Vue.use(VueAwesomeSwiper)

/*axios全局配置*/
console.log("当前环境：" + process.env.NODE_ENV) //打印结果为production 或 development
if (process.env.NODE_ENV == "development") {
  axios.defaults.baseURL = app.baseURL = app.baseURL_dev;
} else {
  axios.defaults.baseURL = app.baseURL = app.baseURL_pro;
}
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.transformRequest = [function (data) {
  data = Qs.stringify(data)
  return data;
}];
axios.defaults.transformResponse = [function (data) {
  data = JSON.parse(data)
  // 405登录失效处理
  if (data.status == 405) {
    localStorage.clear();
    setTimeout(function () {
      myVue.$Message.info("登录已失效，请重新登录");
    }, 3000);
  }
  return data;
}];

Vue.config.productionTip = false

const mystore = new Vuex.Store({
  state: {
  },
  mutations: {},
  getters: {},
  actions: {}
})

/* eslint-disable no-new */
var myVue = new Vue({
  el: '#app',
  router,
  store: mystore,
  components: {
    App
  },
  template: '<App/>'
})



/* 路由跳转前，执行 */
router.beforeEach((to, from, next) => {
  next();
})

/* 路由进入时，执行 */
router.beforeResolve((to, from, next) => {
	var localhref = to.path;
//	console.log(to)
//	console.log(localhref)
  if (to.meta.needLogin) {
    // 获取 api_token：约定后端以cookie形式返回api_token
    var cktoken = app.getCookie("api_token");
    if (cktoken) {
      localStorage.setItem("api_token", cktoken);
      app.delCookie("api_token");
      console.log("localStorage保存api_token，cookie删除api_token")
    }
    // 验证 api_token是否有效
    if (localStorage.getItem("api_token")) {
      axios({
          method: 'get',
          url: '/api/users/info',
          params: {
            p: "w",
            api_token: localStorage.getItem("api_token")
          }
        })
        .then(function (rlt) {
          if (rlt.data.status == 1) {
            next();
          } else {
            localStorage.removeItem("api_token");
            myVue.$Message.info("登录已失效，请重新登录");
            window.location.href = app.baseURL+"/wx_oauth?vue_url="+localhref
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      myVue.$Message.info("未登录，请先登录");
      window.location.href = app.baseURL+"/wx_oauth?vue_url="+localhref
    }
  } else {
    next();
  }
})
/* 路由跳转后，执行 */
router.afterEach((to, from) => {
  // 返回顶部
  window.scrollTo(0, 0);
})


// WEBPACK FOOTER //
// ./src/main.js